module.exports = __webpack_public_path__ + "static/img/WechatIMG@2x.f88c000.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/gallery/WechatIMG@2x.png
// module id = gxgu
// module chunks = 1